<template>
    <b-modal ref="mdlModalitaSomministrazioneEdit" size="lg" :title="titoloModale" no-close-on-backdrop no-close-on-esc centered scrollable>
        <div class="sa-tab-scroll">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <span class="sa-label-data">Nome</span>
                    <b-form-input v-model="jsonDataModalitaSomministrazione.nome"> </b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <span class="sa-label-data">Descrizione</span>
                    <b-form-input v-model="jsonDataModalitaSomministrazione.descrizione"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <span class="sa-label-data">Tipologia</span>
                    <b-form-select v-model="jsonDataModalitaSomministrazione.tipologia" :options="tipologiaOptions" value-field="value" text-field="text"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <span class="sa-label-data">Ordering</span>
                    <b-form-input v-model="jsonDataModalitaSomministrazione.ordering" type="number"></b-form-input>
                </b-col>
            </b-row>
        </div>
        <template #modal-footer>
            <b-button size="md" variant="outline-secondary" @click="onClickIndietro"> Annulla </b-button>

            <b-button variant="outline-success" @click="onSalvaModalitaSomministrazione"> Salva Modalità Somministrazione </b-button>
        </template>
    </b-modal>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    name: "ConfigurazioneModalitaSomministrazioneModalEditComponent",

    data() {
        return {
            titoloModale: "Modifica Modalità Somministrazione",
            jsonDataModalitaSomministrazione: {
                id: "",
                nome: "",
                descrizione: "",
                ordering: "",
                tipologia: "TUTTE",
            },
            pathResource: "/rsapazienteprescrizionimodalitasomministrazione",
            tipologiaOptions: [
                { text: "TUTTE", value: null },
                { text: "SOLUZIONE", value: "SOLUZIONE" },
                { text: "FARMACO", value: "FARMACO" },
                { text: "ELASTOMERO", value: "ELASTOMERO" },
            ],
        };
    },
    methods: {
        show(item) {
            let data = item
                ? Object.assign({}, item)
                : {
                      id: "-1",
                      nome: "",
                      descrizione: "",
                      tipologia: null,
                      ordering: "",
                  };
            this.jsonDataModalitaSomministrazione = data;
            this.titoloModale = data.id === "-1" ? "Nuova Modalità Somministrazione" : "Modifica Modalità Somministrazione";
            this.$refs.mdlModalitaSomministrazioneEdit.show();
        },
        onClickIndietro() {
            this.$refs.mdlModalitaSomministrazioneEdit.hide();
        },
        onSalvaModalitaSomministrazione() {
            let me = this;
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonDataModalitaSomministrazione, me.loadDataModalitaSomministrazioneSuccess, me.loadDataModalitaSomministrazioneError);
        },
        loadDataModalitaSomministrazioneSuccess() {
            this.$bvModal.msgBoxOk("Modalità Somministrazione salvata con successo.", {
                title: "Salvataggio completato",
                size: "sm",
                okVariant: "success",
                centered: true,
            });
            this.$refs.mdlModalitaSomministrazioneEdit.hide();
            this.$emit("afterSave");
        },
        loadDataModalitaSomministrazioneError(error) {
            console.log("Errore nel salvataggio della modalità somministrazione:", error.response.data.messaggio);
        },
    },
};
</script>
